import { Box, Button, CircularProgress, Typography, withStyles } from "@material-ui/core";
import React, { useEffect, useState }from "react";
import Styles from "../commonStyles";
import AuthContainer from "../_components/AuthContainer";
import CommonPopup from "../_components/CommonPopup";
import InputPaper from "../_components/InputPaper";
import PasswordPolicy from "../_components/PasswordPolicy";
import TBTooltip from "../_components/TBTooltip";
import strings from "../_constants/strings";
import actions from "../_fpactions/fpswdactions";

function ChangePassword(props) {
  const { classes, state, setState, callBack, user } = props;
  const {
    TITLES: { CHANGE_PASS },
    LABELS: { OLD_PASSWORD, NEW_PASSWORD, CONFIRM_PASSWORD },
    MESSAGES: { FIRST_LOGIN_CHANGE_PASS },
    ERRORS: { E_PASSWORD_MATCH, E_PASSWORD_CHECK },
  } = strings;
  const { submitting } = state;
  const [openPopUp, setOpenPopup] = useState(false)
  useEffect(()=>{
    if(state.error.msg==="Invalid Auth Token."){
      setOpenPopup(true)
    }
  },[state, openPopUp]);
  const handlepasswordsubmit = e => {
    e && e.preventDefault();
    if (!state.newpassword || state.error.newpassword
      || !state.confirmpassword || state.error.confirmpassword
      || (user && !state.oldpassword) /* || (user && state.error.oldpassword) */) {
      setState({ type: actions.NEW_PASSWORD_SUBMIT_FAILURE, data: E_PASSWORD_CHECK });
    } else {
      setState({ type: actions.SUBMIT_PASSWORD, callBack, user });
      callBack && callBack();
    }
  };

  const handlepopup =()=>{
    window.open("/","_self")
  }
  const handleOldPassword = e => {
    setState({
      type: "ENTER_OLDPASSWORD",
      data: e.target.value
    });
  };
  const handlenewpassword = e => {
    setState({
      type: "ENTER_NEWPASSWORD",
      data: e.target.value
    });
  };
  const handleconfirmpassword = e => {
    setState({
      type: "CONFIRM_PASSWORD",
      data: e.target.value
    });
  };
  return (
    <AuthContainer formtype="change password">
      <Box className={classes.formBox}>
        <Typography gutterBottom className={classes.formtitle}>
          {CHANGE_PASS}
        </Typography>

        {user && user.isFirstLogin && <Typography style={{ fontSize: 14, marginBottom: 10, marginTop: -10 }}>
          {FIRST_LOGIN_CHANGE_PASS}
        </Typography>}

        {user &&
          <InputPaper
            autoFocus
            inputtype="password"
            value={state.oldPassword}
            name={OLD_PASSWORD}
            placeholder={OLD_PASSWORD}
            error={state.error.oldPassword ? true : false}
            handler={handleOldPassword}
            alt_text="newpassword-icon"
            disabled={submitting}
          />
        }

        <InputPaper
          autoFocus={!user}
          inputtype="password"
          value={state.newpassword}
          name={NEW_PASSWORD}
          placeholder={NEW_PASSWORD}
          error={state.error.newpassword ? true : false}
          handler={handlenewpassword}
          image="../images/changepass1st.svg"
          alt_text="newpassword-icon"
          errorMsg={!!state.error.newpassword ? <PasswordPolicy /> : null}
          disabled={submitting}
        />

        <InputPaper
          inputtype="password"
          value={state.confirmpassword}
          name={CONFIRM_PASSWORD}
          placeholder={CONFIRM_PASSWORD}
          error={state.error.confirmpassword ? true : false}
          handler={handleconfirmpassword}
          image="../images/changepass2nd.svg"
          alt_text="confirmpassword-icon"
          errorMsg={!!state.error.confirmpassword ? E_PASSWORD_MATCH : null}
          disabled={submitting}
        />

        <Typography
          className={classes.errormsg}
          variant="caption"
          display="block"
          gutterBottom
        >
          {state.error.msg}
        </Typography>

        <Button
          variant='contained'
          type="submit"
          className={classes.loginbutton}
          onClick={handlepasswordsubmit}
          disabled={submitting}
        >
          Submit
          {submitting ? <CircularProgress size="15" className={classes.spinner} /> : ""}
        </Button>
        <TBTooltip
          title={<PasswordPolicy />}>
          <Typography
            className={classes.fgtpasswdlink}
            style={{ fontSize: 14, cursor: "pointer", marginTop: -10 }}>
            Password Policy
          </Typography>
        </TBTooltip>
        <CommonPopup
          openState={openPopUp}
          popupText={state.error.msg}
          handleClick={handlepopup}
        ></CommonPopup>
      </Box>
    </AuthContainer>
  );
}
export default withStyles(Styles)(ChangePassword);
